module.exports = __webpack_public_path__ + "img/recovery-flowchart.d1e13270.png";